import {useCurrentState} from "../globalState";
import {useAPI} from "../stateHelpers";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import React, {useRef, useState} from "react";
import {withRouter} from "react-router-dom";
import {IconButton, ListItemSecondaryAction, Typography} from "@material-ui/core";
import {ValidatorForm} from "react-form-validator-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import {apiDelete, apiPost, apiPut, apiURL} from "../api";
import snackbar from "../snackbar";
import spawnConfirmation from "../confirmationDialog";
import {GenerateInputs} from "./GenericInputField";
import FailedLoading from "./FailedLoading";
import CircularLoader from "./CircularLoader";
import uuid4 from "uuid4";


function AccessTokensPage(props) {

    let [title, setTitle] = useCurrentState("title");
    const {data = [], error, isLoading, setData, doRetry} = useAPI("user/0/access_token");
    let [user, setUser] = useCurrentState("user");
    const inputRef = useRef(null);

    let inputs = GenerateInputs({
        password: {
            label: 'Your password',
            validators: ['required'],
            type: 'password',
            errorMessages: ['this field is required']
        }
    });


    setTitle("Access Tokens");

    const {
        history,
        ...rest
    } = props;

    if (error) {
        return <FailedLoading retry={doRetry}/>
    }

    if (isLoading) {
        return <CircularLoader/>
    }

    let loading = inputs.password.disabled;

    let deleteAccessToken = async (item) => {
        spawnConfirmation().then(() => apiDelete("user/0/access_token/" + item.id).then(() => {
            setData(data.filter((itm) => itm.id !== item.id));
            snackbar("Deleted.");
        }, () => {
            snackbar("Failed deleting. Please try again!");
        }));
    };

    let submit = () => {
        inputs.disableAll(true);
        var dt = inputs.toData();
        dt.email = user.email;
        dt.device_id = uuid4();
        let save = apiPost("login", dt);
        save.then(res => {
            snackbar("Saved.");
            doRetry();
        }, res => {
            snackbar("Error: " + res.response.data.message);
        }).finally(() => inputs.disableAll(false));
    };


    let reset = () => {
        for (let key of Object.keys(inputs)) {
            let field = inputs[key];
            if (field.setValue) {
                field.setValue("");
            }
        }
    };

    return (
        <div>
            <div style={{padding: 16}}>
                <div>
                    <Card>
                        <CardContent>
                            <div>
                                <Typography variant="h5" component="h2">Add new access token</Typography>
                                <div>
                                    <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                                        <div>
                                            {inputs.password.field}
                                        </div>

                                    </ValidatorForm>
                                </div>
                            </div>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => submit()} disabled={loading} color="primary">
                                Create
                            </Button>
                            <Button onClick={() => reset()} disabled={loading} color="primary">
                                Cancel
                            </Button>
                        </CardActions>
                    </Card>
                </div>
            </div>
            <List>
                {(data || []).map((item) => <ListItem
                    key={item.id} alignItems="flex-start">
                    <ListItemText
                        primary={item.session.token}
                        secondary={item.created_at}
                    />
                    <ListItemSecondaryAction>
                        <IconButton onClick={() => deleteAccessToken(item)}>
                            <Delete/>
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>)}
            </List>
        </div>
    )
}

export default withRouter(AccessTokensPage);